var path = '/client/common/modules/abstract-picker/views/partials/abstract-picker-selection.html';
var html = "<div class=\"abstract-picker-selection\">\n    {{ ::selectedObject.id || selectedObject }}\n</div>\n";
window.angular.module('AppTemplates').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;